import {
  ANDROID_APK_FILE_NAME,
  readAndroidApkConfig,
} from '../../core/config/androidApkConfig';

export type AndroidApkDownload = {
  url: string;
  fileName: string;
};

/**
 * Resolve a downloadable Android APK URL for the signed-in user.
 * Prefers Hosting/CDN (`VITE_ANDROID_APK_URL` or derived Hosting path), then Storage.
 */
export async function resolveAndroidApkDownload(
  env: Record<string, string | undefined> = import.meta.env as Record<string, string | undefined>,
): Promise<AndroidApkDownload | null> {
  const config = readAndroidApkConfig(env);
  if (config.url) {
    return { url: config.url, fileName: config.fileName };
  }

  try {
    const [{ storage }, { ref, getDownloadURL }] = await Promise.all([
      import('../../config/firebase'),
      import('firebase/storage'),
    ]);
    const url = await getDownloadURL(ref(storage, config.storagePath));
    return { url, fileName: config.fileName || ANDROID_APK_FILE_NAME };
  } catch {
    return null;
  }
}
